import React from 'react';
import { produce } from 'immer';
import { IModalContext, ModalContext } from './ModalContext';

class ModalProvider extends React.PureComponent<{}, IModalContext> {
  constructor(props: {}) {
    super(props);
    this.state = {
      close: this.close,
      isOpen: false,
      openSupportingLinks: this.openSupportingLinks,
      links: [],
    };
  }

  render = () => (
    <ModalContext.Provider value={this.state}>
      {this.props.children}
    </ModalContext.Provider>
  );

  private openSupportingLinks = (links: string[]) =>
    this.setState(state =>
      produce(state, draft => {
        draft.isOpen = true;
        draft.links = links;
      }),
    );

  private close = () =>
    this.setState(state =>
      produce(state, draft => {
        draft.isOpen = false;
      }),
    );
}

export default ModalProvider;
